export const contentLevelOptions = t => [
	{ key: t('beginner'), value: 'beginner' },
	{ key: t('intermediate'), value: 'intermediate' },
	{ key: t('advanced'), value: 'advanced' }
];

export const contentLevelLabel = (value, t) =>
	contentLevelOptions(t).find(item => item.value === value)?.key || t('beginner');
